'use client';

import ArrowLeftBlack2424 from '@svg/main/arrow_left_black_24_24.svg';

export default function SurveyTopBar({ title, onClickBack }: { title: string; onClickBack: () => void }) {
  return (
    <>
      <div className='h-56pxr w-full fixed z-20 max-w-480pxr top-0 p-16pxr flex items-center justify-between border-b border-gray-200 bg-white'>
        <button
          className='w-24pxr h-24pxr'
          onClick={() => {
            onClickBack();
          }}
        >
          <ArrowLeftBlack2424 className='flex-none' />
        </button>

        <h2 className='heading-18-bold'>{title}</h2>
        <span className='w-24pxr h-24pxr'></span>
      </div>
      <div className='h-56pxr flex-none'></div>
    </>
  );
}
